import { Row, Col } from "../../App.styles";

const key = process.env.REACT_APP_GOOGLE_API_KEY;

const LocationSection = ({ useQuery }) => {
  const { address, latitude, longitude } = useQuery();

  return (
    <>
      <Row>
        <Col>
          <p>Completion Location: {address}</p>
        </Col>
      </Row>
      <br />
      <iframe
        title={address}
        width="100%"
        height="300"
        frameBorder="0"
        scrolling="no"
        marginHeight="0"
        marginWidth="0"
        src={`https://www.google.com/maps/embed/v1/place?key=${key}&q=${latitude},${longitude}&center=${latitude},${longitude}`}
      />
    </>
  );
};

export default LocationSection;
